import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=b7d691c8&scoped=true&"
import script from "./FormItem.vue?vue&type=script&lang=js&"
export * from "./FormItem.vue?vue&type=script&lang=js&"
import style0 from "./FormItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormItem.vue?vue&type=style&index=1&id=b7d691c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d691c8",
  null
  
)

export default component.exports